// React
import { useMemo } from "react"

// Dates
import { useToday } from "@/hooks/useToday"

// I18n
import { useLang } from "@/context/useLang"
import { useTrans } from "@/i18n"

// UI
import { useInvestmentsGraphProductionData } from "./useInvestmentsGraphProductionData"

// Graphs
import {
	AvailableDatePeriods,
	useProductionGraphContext,
} from "@/components/graphs/types/bar/ProductionGraphContext"
import { GraphHeader } from "@/components/graphs/header/GraphHeader"

/**
 * InvestmentsGraphProductionHeader
 * @returns
 */
export function InvestmentsGraphProductionHeader() {
	const t = useTrans("finance")
	const { formatNumber } = useLang()
	const today = useToday()
	const { data } = useInvestmentsGraphProductionData()
	const { graphInterval } = useProductionGraphContext()

	const amount = useMemo(() => {
		return data?.me?.investor_production_stats?.production_data
			?.reduce((acc, curr) => {
				const value = curr?.production ? parseFloat(curr.production) : 0
				return value ? acc + value : acc
			}, 0)
			.toFixed(2)
	}, [data])

	return (
		<>
			{graphInterval === AvailableDatePeriods.MONTH ? (
				<GraphHeader
					title={t("finance:data.production.yearly.title", {
						year: today.year,
					})}
					subtitle={t("finance:data.production.yearly.subtitle", {
						amount: amount ? formatNumber(parseFloat(amount)) : 0,
					})}
				/>
			) : (
				<GraphHeader
					title={t("finance:data.production.monthly.title", {
						month: today.toLocaleString({
							month: "long",
						}),
					})}
					subtitle={t("finance:data.production.monthly.subtitle", {
						amount: amount ? formatNumber(parseFloat(amount)) : 0,
					})}
				/>
			)}
		</>
	)
}
